export default {
      id: "check-usage",
      viewBox: "0 0 15 11",
      url: "/" + "sprite.svg#check",
      toString: function () {
        return this.url;
      }
    }